import React, { useContext } from 'react'

import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import { DetailItemCardVariant } from '../common/types'
import SaveTripItemButton from '../../Buttons/SaveTripItemButton'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import { VIEW_OFFER_COPY } from 'tripPlanner/config'
import {
  TourItem,
} from 'tripPlanner/types/tripItem'
import { getItineraryDaysCount } from '../utils'
import TourV2OfferCardPriceDetails from 'tripPlanner/components/ItemOfferPrice/TourV2PriceDetails'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import GeoContext from 'contexts/geoContext'
import TourCTAContent from '../CTAContent/TourCTAContent'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'

interface Props {
  item: Utils.RequiredProp<TourItem, 'savedItemData'>
  offer: App.Tours.TourV2Offer
  viewAsTemplate: boolean
  variant: DetailItemCardVariant
}

function TourV2PriceAndCTAs({ item, offer, viewAsTemplate, variant }: Props) {
  const { currentCurrency } = useContext(GeoContext)
  const { cheapestPurchasableOption, cheapestVariation } =
    useCheapestOfTourV2Offer(offer)

  if (item.isSuggested) {
    // We don't currently do suggested tours. If we ever do, update this.
    return null
  }

  const offerLink = buildProductLink(item, !viewAsTemplate, { offer }) ?? ''

  const isOfferAvailable = !!(cheapestPurchasableOption && cheapestVariation)

  const priceAreaContent =
    cheapestPurchasableOption && cheapestVariation ?
      <TourV2OfferCardPriceDetails
        depositComponent={null}
        purchasableOption={cheapestPurchasableOption}
        duration={getItineraryDaysCount(cheapestVariation)}
        currencyCode={currentCurrency}
      /> :
      <StatusLabel variant="cancelled">Sold Out</StatusLabel>

  let ctaAreaContent: JSX.Element | undefined = undefined

  if (viewAsTemplate) {
    ctaAreaContent = (
      <Group direction="horizontal" gap={12}>
        <SaveTripItemButton item={item} />
        <TextButton kind="primary" to={offerLink} target="_blank">
          {VIEW_OFFER_COPY}
        </TextButton>
      </Group>
    )
  } else {
    ctaAreaContent = (
      <TourCTAContent
        item={item}
        isOfferAvailable={isOfferAvailable}
        variant={variant}
        offerLink={offerLink}
      />
    )
  }

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default TourV2PriceAndCTAs
